import { StatusType } from '@app/components/various/Status';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  status: StatusType;
}

export const InvoiceStatusLabel = ({ status }: Props) => {
  const { t } = useTranslation(['invoices']);

  const statusLabel = React.useMemo(() => {
    switch (status) {
      case 'paid':
        return t('invoices:paid');
      case 'notPaid':
        return t('invoices:not_paid');
      case 'overdue':
        return t('invoices:overdue');
      case 'pending':
        return t('invoices:pending');
      default:
        return '';
    }
  }, [status, t]);

  return <span data-testid="invoice-status-label">{statusLabel}</span>;
};
